module.exports = __webpack_public_path__ + "img/smile.16e743cf.png";